import { HistoryEventParameters } from '@api/types';

enum TermNames {
  gdpr = 'GDPR',
  imei = 'IMEI',
}

class DefaultUpdater {
  check(): boolean {
    return true;
  }

  updateParams(params: HistoryEventParameters): void {
    params.fullNameOrEmail = params.full_name || params.email;
    params.secretVersion = params.secret_version;
    params.appName = params.mobile_app_name;
    params.termName = TermNames[String(params.term_name)] || params.term_name;
  }
}

export const defaultUpdater = new DefaultUpdater();
